// extracted by mini-css-extract-plugin
export var content = "_8v-3";
export var list = "_8v-4";
export var settingsContent = "_8v-7";
export var settingsPanel = "_8v-8";
export var state = "_8v-6";
export var triggerBadge = "_8v-2";
export var triggerButton = "_8v-1";
export var triggerShell = "_8v-0";
export var unreadDot = "_8v-5";